import PeriodResultTable, { ResultLeague } from "./PeriodResultTable";

const periodColumns = [
  { label: "Set 1", type: "set", number: 1 },
  { label: "Set 2", type: "set", number: 2 },
  { label: "Set 3", type: "set", number: 3 },
  { label: "Set 4", type: "set", number: 4 },
  { label: "Set 5", type: "set", number: 5 },
];
const summaryColumns = [
  { label: "Total Points", key: "totalScore" },
  { label: "Total Sets", key: "totalSets" },
];

const VolleyballResultTable = ({ leagues }: { leagues: ResultLeague[] }) => (
  <PeriodResultTable
    leagues={leagues}
    periodColumns={periodColumns}
    summaryColumns={summaryColumns}
  />
);

export default VolleyballResultTable;
